/**
 * ファイルアイコンユーティリティ
 * MIMEタイプに基づいてアイコンを返す
 */

import {
  FaImage,
  FaFilePdf,
  FaFileAlt,
  FaCode,
  FaGlobe,
  FaPalette,
  FaPython,
  FaJava,
  FaGem,
  FaPhp,
  FaMobileAlt,
  FaDatabase,
  FaTerminal,
  FaTable,
  FaPaperclip,
} from 'react-icons/fa';
import { SiRust, SiGo } from 'react-icons/si';

export const getFileIcon = (mimeType: string): React.ReactNode => {
  // 画像
  if (mimeType.startsWith('image/')) return <FaImage />;
  // ドキュメント
  if (mimeType === 'application/pdf') return <FaFilePdf />;
  // データ形式
  if (mimeType === 'application/json') return <FaFileAlt />;
  if (mimeType.includes('xml')) return <FaFileAlt />;
  if (mimeType.includes('yaml')) return <FaFileAlt />;
  // マークダウン
  if (mimeType === 'text/markdown') return <FaFileAlt />;
  // HTML/CSS
  if (mimeType === 'text/html') return <FaGlobe />;
  if (mimeType === 'text/css' || mimeType.includes('scss') || mimeType.includes('less'))
    return <FaPalette />;
  // プログラミング言語
  if (mimeType.includes('javascript') || mimeType.includes('typescript')) return <FaCode />;
  if (mimeType.includes('python')) return <FaPython />;
  if (mimeType.includes('java')) return <FaJava />;
  if (mimeType.includes('ruby')) return <FaGem />;
  if (mimeType.includes('go')) return <SiGo />;
  if (mimeType.includes('rust')) return <SiRust />;
  if (mimeType.includes('php')) return <FaPhp />;
  if (mimeType.includes('swift') || mimeType.includes('kotlin')) return <FaMobileAlt />;
  if (mimeType.includes('sql')) return <FaDatabase />;
  if (mimeType.includes('sh') || mimeType.includes('bash')) return <FaTerminal />;
  // CSV/TSV
  if (mimeType === 'text/csv' || mimeType === 'text/tab-separated-values') return <FaTable />;
  // テキスト
  if (mimeType.startsWith('text/')) return <FaFileAlt />;
  return <FaPaperclip />;
};
